import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'mk-loader',
  templateUrl: './mk-loader.component.html',
  styleUrls: ['./mk-loader.component.scss']
})
export class MKLoaderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
